// extracted by mini-css-extract-plugin
module.exports = {"Button":"LinkCancel_Button__3u0Fq","NextArrow":"LinkCancel_NextArrow__2z6Ds","Error":"LinkCancel_Error__2p_ri"};